<script>
	import RoundClose from 'virtual:icons/ic/round-close';
	import logoMinimalImg from '@lib/images/logo/brand-minimal.svg';
	import ArrowBackOutline from 'virtual:icons/ion/arrow-back-outline';
	import Footer from '@components/global/Footer/Index.svelte';
	import Header from '@components/global/Header/Index.svelte';
	import NavLogo from '@components/global/micro/NavLogo.svelte';
	import { page } from '$app/stores';
	import { goto } from '$app/navigation';
	import Container from '@components/global/Container.svelte';
	import { PUBLIC_SITE_NAME } from '$env/static/public';
	import { slide } from 'svelte/transition';
	import CallCsButton from '@lib/components/global/micro/CallCSButton.svelte';
	import MainMenu from '@lib/components/app/MainMenu.svelte';

	$: backUrl = $page.url.searchParams.get('back_url');
	$: isShowDownloadRow = $page.url.pathname !== '/download-app';
</script>

<Header isIncludeBackUrl={!!backUrl}>
	<div slot="header-top-row">
		{#if isShowDownloadRow}
			<div
				transition:slide
				class="download-app-row bg-primary bg-gradient-to-tr py-4 text-primary-content"
			>
				<Container>
					<div class="flex items-center justify-between gap-3">
						<div class="flex items-center gap-3">
							<button
								on:click={() => (isShowDownloadRow = false)}
								type="button"
								class="btn btn-circle btn-sm border-none bg-base-100"
							>
								<RoundClose class="text-base" />
							</button>
							<div class="grid aspect-square size-10 place-items-center rounded-md bg-base-100 p-2">
								<img class="w-full" src={logoMinimalImg} alt={PUBLIC_SITE_NAME} />
							</div>
							<p
								class="flex-1 text-balance text-xs font-medium leading-normal text-base-100 xs:text-sm"
							>
								Download dan baca semua buku favoritmu!
							</p>
						</div>
						<a
							href="/download-app"
							class="btn btn-sm rounded-full border-none bg-base-100 text-primary"
						>
							Download
						</a>
					</div>
				</Container>
			</div>
		{/if}
	</div>
	<div slot="header-logo" class="relative">
		<div class="flex items-center gap-5">
			<NavLogo class={backUrl ? 'hidden pre-md:block' : ''} />
			<div class="hidden pre-sm:block pre-md:hidden md:block">
				<MainMenu />
			</div>
		</div>
		{#if backUrl}
			<button
				on:click={() => goto(backUrl)}
				type="button"
				class="btn flex items-center gap-2 rounded-full pre-md:hidden"
				aria-label="Kembali"
				title="Kembali"
			>
				<ArrowBackOutline class="text-xl" />
				Kembali
			</button>
		{/if}
	</div>
</Header>
<slot class="overflow-hidden" />
<Footer />

<CallCsButton />

<style>
	@media (pointer: fine) {
		.download-app-row {
			display: none;
		}
	}
</style>
